import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { CredentialProperties } from './credential-properties';

@Metamodel.model({
    name: ModelConstants.userAuthCredentialProperties,
    display: [shellStringResources.ModelName_UserAuthCredentialProperties]
})
export class UserAuthCredentialProperties extends CredentialProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.Token
    })
    public token: string;

    @Metamodel.attribute({
        display: shellStringResources.PrincipalId
    })
    public principalId: string;
}
